import React from 'react';
import Head from 'next/head';

function MetaTag({ title }: { title?: string }) {
  return (
    <Head>
      <title>{title || 'Populate Survey App'}</title>
      <meta
        name="description"
        content="Streamlined medical records software for clinicians who specialize in the musculoskeletal system of populate"
      />
      <link rel="icon" href="/favicon.ico" />
    </Head>
  );
}

export default MetaTag;
